import { render, staticRenderFns } from "./search-invoice.vue?vue&type=template&id=72340d8d&"
import script from "./search-invoice.vue?vue&type=script&lang=js&"
export * from "./search-invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports